import { bindActionCreators } from 'redux';
import { useDispatch } from 'react-redux';
import { useMemo } from 'react';

type TActions = {
  [key: string]: Function;
};

export function useActions<T extends TActions>(actions: T, deps: any[] = []): T {
  const dispatch = useDispatch();
  const list = useMemo<T>(() => {
    const keys = Object.keys(actions);
    const boundActions: TActions = {};

    keys.forEach((name: string) => {
      boundActions[name] = bindActionCreators<any, any>(actions[name], dispatch);
    });

    return boundActions as T;

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, ...deps]);

  return list;
}

export default useActions;
